// extracted by mini-css-extract-plugin
export var categoryProduct = "wb";
export var categoryProductImg = "xb";
export var categoryProductImgColors = "yb";
export var categoryProductName = "zb";
export var categoryProductOrigin = "Ab";
export var categoryProductPriceCn = "Bb";
export var categoryProductPriceEn = "Cb";
export var categoryProductTag = "Db";
export var categoryProductTagLine = "Eb";